/** One tiny synthesized sound: a soft pop when someone speaks. No files, no autoplay before a gesture. */
let ctx: AudioContext | undefined
let last = 0

export function pop(): void {
  const now = performance.now()
  if (now - last < 120) return
  last = now
  try {
    ctx ??= new AudioContext()
    // Browsers keep audio suspended until a gesture; skip this pop rather than queue it.
    if (ctx.state !== 'running') { void ctx.resume(); return }
    const t = ctx.currentTime
    const o = ctx.createOscillator()
    const g = ctx.createGain()
    o.type = 'sine'
    o.frequency.setValueAtTime(520 + Math.random() * 160, t)
    o.frequency.exponentialRampToValueAtTime(980, t + 0.06)
    g.gain.setValueAtTime(0.0001, t)
    g.gain.exponentialRampToValueAtTime(0.06, t + 0.01)
    g.gain.exponentialRampToValueAtTime(0.0001, t + 0.14)
    o.connect(g).connect(ctx.destination)
    o.start(t)
    o.stop(t + 0.16)
  } catch { /* no audio: fine */ }
}
